import lazyLoading from "./lazyLoading";

const memberSettingsMeta = {
  viewTitle: "Settings",
  menuIcon: "settings",
  auth: true
};

export const memberSettingsRoutes = {
  path: "/member-settings",
  name: "MemberSettings",
  redirect: "/member-settings/profile",
  component: lazyLoading("MemberSettings"),
  meta: {
    ...memberSettingsMeta
  },
  children: [
    {
      path: "profile",
      name: "MemberProfileSettings",
      meta: {
        ...memberSettingsMeta,
        linkTitle: "PROFILE"
      },
      component: lazyLoading("MemberProfileSettings")
    },
    {
      path: "account",
      name: "MemberAccount",
      meta: {
        ...memberSettingsMeta,
        linkTitle: "ACCOUNT"
      },
      component: lazyLoading("MemberAccount")
    },
    // {
    //   path: "steps-reminders",
    //   name: "MemberStepsReminders",
    //   meta: {
    //     ...memberSettingsMeta,
    //     linkTitle: "STEPS/REMINDERS"
    //   }
    // },
    {
      path: "device",
      name: "MemberDevice",
      meta: {
        ...memberSettingsMeta,
        linkTitle: "DEVICE"
      },
      component: lazyLoading("MemberDevice")
    }
  ]
};

export default memberSettingsRoutes;
